var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.67,
    height: 15.559,
    viewBox: "0 0 12.67 15.559",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "delete",
    transform: "translate(0.057 0.05)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13651",
    "data-name": "Path 13651",
    d: "M222.76,154.7a.362.362,0,0,0-.362.362v6.843a.362.362,0,1,0,.724,0v-6.843A.362.362,0,0,0,222.76,154.7Zm0,0",
    transform: "translate(-214.346 -149.102)",
    fill: "#e94560",
    stroke: "#e94560",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13652",
    "data-name": "Path 13652",
    d: "M104.76,154.7a.362.362,0,0,0-.362.362v6.843a.362.362,0,1,0,.724,0v-6.843A.362.362,0,0,0,104.76,154.7Zm0,0",
    transform: "translate(-100.618 -149.102)",
    fill: "#e94560",
    stroke: "#e94560",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13653",
    "data-name": "Path 13653",
    d: "M1.025,4.6v8.92A2,2,0,0,0,1.556,14.9a1.783,1.783,0,0,0,1.294.559H9.7a1.782,1.782,0,0,0,1.294-.559,2,2,0,0,0,.531-1.378V4.6a1.383,1.383,0,0,0-.355-2.72H9.316V1.429A1.422,1.422,0,0,0,7.882,0H4.667a1.422,1.422,0,0,0-1.434,1.43v.453H1.38A1.383,1.383,0,0,0,1.025,4.6ZM9.7,14.734H2.85a1.147,1.147,0,0,1-1.1-1.213V4.633H10.8v8.888a1.147,1.147,0,0,1-1.1,1.213ZM3.958,1.429a.7.7,0,0,1,.71-.706H7.882a.7.7,0,0,1,.71.706v.453H3.958ZM1.38,2.605h9.79a.652.652,0,0,1,0,1.3H1.38a.652.652,0,0,1,0-1.3Zm0,0",
    transform: "translate(0.003 0.002)",
    fill: "#e94560",
    stroke: "#e94560",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13654",
    "data-name": "Path 13654",
    d: "M163.76,154.7a.362.362,0,0,0-.362.362v6.843a.362.362,0,1,0,.724,0v-6.843A.362.362,0,0,0,163.76,154.7Zm0,0",
    transform: "translate(-157.482 -149.102)",
    fill: "#e94560",
    stroke: "#e94560",
    strokeWidth: 0.1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.56187256087533fe2cdd601458da6a5c.svg";
export { ForwardRef as ReactComponent };